import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import "./Card.css";

const Card = ({
  showNotifications,
  setShowNotifications,
  setAllNotifications,
  allnotifications,
}) => {
  const navigate = useNavigate();

  useEffect(() => {
    if (showNotifications) {
      const updated = allnotifications.map((n) =>
        !n.read ? { ...n, read: false } : n
      );
      setAllNotifications(updated);
    }
  }, [showNotifications]);

  const handleViewAll = () => {
    setShowNotifications(false);
    navigate("/notifications/duplicate-webhook");
  };

  return (
    <div className="notification-dropdown">
      <div className="notification-header-title">Notifications</div>

      <div className="notification-scroll">
        {Array.isArray(allnotifications) && allnotifications.length > 0 ? (
          allnotifications.slice(0, 10).map((n, index) => (
            <div
              key={index}
              className={`notification-items ${!n.read ? "highlighted" : ""}`}
            >
              <div className="notif-message">{n.message}</div>
              {n.type !== 'ip_whitelist_request' && (
                <div className="notif-subtext">
                  Order ID: <span>{n.orderId}</span>
                </div>
              )}
              <div className="notif-subtext">
                Type: <span>{n.type}</span>
              </div>
              <div className="notif-time">
                {new Date(n.createdAt).toLocaleString()}
              </div>
            </div>
          ))
        ) : (
          <div className="no-notifications">No notifications</div>
        )}
      </div>

      <div className="view-all-notification" onClick={handleViewAll}>
        View All
      </div>
    </div>
  );
};

export default Card;
